// PH-75: request-otp refuses to replace a code that is still valid. That refusal (HTTP 429) is
// routine now: any earlier request, the owner's own or a stranger's, blocks a new one for up to
// the code's whole 10-minute life. The backend names the channel the outstanding code went to in
// the `X-OTP-Pending-Channel` response header, on that one 429 only, so a screen can open the
// code-entry box for it instead of leaving the owner on the channel picker.
//
// This reads the header rather than the error text (`detail`), which is display copy and may change.
// It lives outside services/api.js on purpose: tests `jest.mock('../services/api')` wholesale, and
// an automocked copy of this helper would silently return undefined.
const HEADER = 'x-otp-pending-channel';

export function pendingOtpChannel(err) {
  const res = err && err.response;
  if (!res || res.status !== 429 || !res.headers) return null;
  const h = res.headers;
  const value = typeof h.get === 'function' ? h.get(HEADER) : (h[HEADER] ?? h['X-OTP-Pending-Channel']);
  return value === 'phone' || value === 'email' ? value : null;
}
